var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"navbar"},_vm._l((_vm.navList),function(item,index){return _c('div',{key:index,staticClass:"nav-item",class:{current: _vm.tabIndex == index},on:{"click":function($event){return _vm.tabClick(index)}}},[_vm._v(" "+_vm._s(item)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }